export default "__VITE_ASSET__e3c7fd44__"